import React, { useContext } from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { getLastPathElement } from '../../../util/StringUtil'
import { PersonContext } from '../PersonContext'
import { UserLink } from '../../app/Links'
import DataView from '../../common/DataView'

const smallLink = css`
  margin-inline-start: 5px !important;
  margin-bottom: 2px !important;
  font-size: smaller;
  line-height: 18px;
`

export default function FactDataView({ fact }) {
  const { t } = useTranslation()
  const userNames = useContext(PersonContext).currentPerson.contactNames
  const getNameOrDefaultToId = (id) => (id && userNames[id] ? userNames[id] : id)
  const contributorId = fact.attribution.contributor ? fact.attribution.contributor.id : null
  const contributorName = getNameOrDefaultToId(contributorId)
  const submitterId = fact.attribution.submitter ? fact.attribution.submitter.id : null
  const submitterName = getNameOrDefaultToId(submitterId)
  const modified = fact.attribution.modifiedDateNormalized ? fact.attribution.modifiedDateNormalized[0].value : null
  const changeMessage = fact.attribution.changeMessage ? fact.attribution.changeMessage : null

  const data = [
    {
      label: t('type', 'Type'),
      detail: t(getLastPathElement(fact.value.type).toLowerCase(), getLastPathElement(fact.value.type)),
    },
  ]
  if (getLastPathElement(fact.value.type) === 'LifeSketch') {
    data.push(
      {
        label: t('value', 'Value'),
        detail: fact.value.value,
      },
      { label: null, detail: null },
      { label: null, detail: null },
      { label: null, detail: null },
      { label: null, detail: null }
    )
  } else {
    data.push(
      {
        label: t('person.summary.labels.date', 'Date (Original)'),
        detail: fact.value.date?.original,
      },
      {
        label: t('person.summary.labels.place', 'Place (Original)'),
        detail: fact?.value?.place?.original,
      },
      {
        label: t('modified.label', 'Modified'),
        detail: modified,
      },
      {
        label: t('person.summary.labels.dateStandardized', 'Date (Standard)'),
        detail: fact.value.date?.normalized?.[0]?.value
          ? fact.value.date.normalized[0].value
          : fact?.value?.date?.standardized,
      },
      {
        label: t('person.summary.labels.placeStandardized', 'Place (Standard)'),
        detail: fact.value.place?.names?.[0]?.value
          ? fact.value.place.names[0].value
          : fact?.value?.place?.standardized,
      }
    )
  }
  data.push(
    {
      label: t('contributor', 'Contributor'),
      detail: <UserLink userId={contributorId} userName={contributorName} css={smallLink} showId />,
    },
    {
      label: t('submitter', 'Submitter'),
      detail: <UserLink userId={submitterId} userName={submitterName} css={smallLink} showId />,
    }
  )

  if (changeMessage) {
    data.push({
      label: t('changeMessage', 'Change Message'),
      detail: changeMessage,
    })
  }
  return <DataView data={data} />
}
